<template>
  <span>
    {{ filteredTwoDigits(duration.minutes()) }}:{{ filteredTwoDigits(duration.seconds()) }}
  </span>
</template>

<script>
import Timer from '@/components/me/Timer.vue'
export default {
  mixins: [Timer],
}
</script>
